/* :Page: Car Upload */
import React, { useState } from "react";
import RenewMotorLayout from "../../renewalMotorPolicy/renewMotorLayout";
import UploadScan from "../../newMotorPolicy/uploads/uploadScan";
import UploadScanRenewal from "../../newMotorPolicy/uploads/uploadScanRenewal";
import useChangePlanFlow from "../../../../hooks/useChangePlanFlow";
import SelectNewPlanLayout from "../selectNewPlan/selectNewPlanLayout";
import AdjustSumInsuredMotorLayout from "../../adjustSumInsuredFlow/adjustSumInsuredMotorLayout";
import useAdjustSumInsuredFlow from "../../../../hooks/useAdjustSumInsured";
import UploadScanAdjustSumInsured from "../../newMotorPolicy/uploads/uploadScanAdjustSumInsured";
import useRenewalFlow from "../../../../hooks/useRenewalFlow";
import { useDispatch, useSelector } from "react-redux";
import { selectNewMotorForm } from "../../../../redux/features/newMotorFormSlice";
import { RENEW_POLICY_SELECTED_POLICY } from "../../renewalMotorPolicy/selectPoliciesPage/selectPoliciesPage";
import { motorRenewalPremium } from "../../../../redux/features/motor/renewalPremiumSlice";
import { getClientSource } from "../../../../utils/getClientSource";
import { toast } from "sonner";
import { unwrapResult } from "@reduxjs/toolkit";
import { getCoverPrices } from "../../../../redux/features/motor/getQuoteSlice";
import { coverPriceRequest } from "../../newMotorPolicy/planPages/data";
import useMotorForm from "../../../../hooks/useMotorFormData";

const UploadPhotosOfCar = (passedFrom) => {
  const { handleNextSubstep, handlePrevSubstep  } = useChangePlanFlow()
  const { handleNextSubstep: handleNextRenewal, handlePrevSubstep: handlePrevRenewal } = useRenewalFlow();
  const dispatch = useDispatch();
  const selectedPolicyRenewalInfo = useSelector(selectNewMotorForm)?.[RENEW_POLICY_SELECTED_POLICY];
  const [selected, setSelected] = useState(null);
  const { saveMotorDataInRedux } = useMotorForm(RENEW_POLICY_SELECTED_POLICY, setSelected);

  const NextHandler = () => {
    handleNextSubstep()
  };

  const NextRenewalHandler = async () => {
    // Check if this is for expired policy renewal
    if (passedFrom.passedFrom.passedFrom == "MotorRenewal" && selectedPolicyRenewalInfo?.PolicyStatus === "EXPIRED") {
      if (!selectedPolicyRenewalInfo?.PolicyNumber) {
        toast.error("Policy information not found");
        return;
      }

      try {
        // Prepare the premium API payload
        const motorRenewalPremiumPayload = {
          PolicyNumber: selectedPolicyRenewalInfo.PolicyNumber,
          Channel: getClientSource(),
          Covers: [],
          DefaultCovers: false,
          NewPlan: "",
        };

        // Call the /policy/motorRenewal API
        const premiumAction = await dispatch(motorRenewalPremium(motorRenewalPremiumPayload));
        const premiumResult = unwrapResult(premiumAction);

        console.log("Premium result is: ", premiumResult);

        // Call cover prices API to populate covers for the enhancement page
        const coverPricesPayload = coverPriceRequest(
          selectedPolicyRenewalInfo.PolicyNumber,
          premiumResult.PlanName,
          "",
          ""
        );
        await dispatch(getCoverPrices(coverPricesPayload));

        // Save updated policy info with OriginalPlanName and OriginalPolicyNo
        const updatedPolicyPremiumResult = {
          ...premiumResult,
          OriginalPlanName: premiumResult.PlanName,
          OriginalPolicyNo: premiumResult.QuoteDetails?.PreviousPolicyNumber || selectedPolicyRenewalInfo.PolicyNumber,
        };
        await saveMotorDataInRedux(updatedPolicyPremiumResult);

        // On success, proceed to next step
        handleNextRenewal();
      } catch (error) {
        // This catch block will handle both network errors and non-200 responses
        console.error("Premium API Error:", error);
        toast.error("Failed to process premium calculation. Please try again.");
      }
    } else {
      // For non-expired policies or other flows, just proceed normally
      handleNextRenewal();
    }
  };

  const { handleNextSubstep: handleNextAdjustSumInsured, handlePrevSubstep: handlePrevAdjustSumInsured } = useAdjustSumInsuredFlow();


  return (
    <>
      {passedFrom.passedFrom.passedFrom == "MotorChangeActivePlan" && (
        <SelectNewPlanLayout
          backClickHandler={handlePrevSubstep}
          show_summary
          btn_onClick={NextHandler}
        >
          <UploadScan />
        </SelectNewPlanLayout>
      )}
      {passedFrom.passedFrom.passedFrom == "MotorAdjustSumInsured" && (
        <AdjustSumInsuredMotorLayout
          backClickHandler={handlePrevSubstep}
          show_summary
          btn_onClick={handleNextAdjustSumInsured}
        >
          <UploadScanAdjustSumInsured />
        </AdjustSumInsuredMotorLayout>
      )}
      {passedFrom.passedFrom.passedFrom == "MotorRenewal" && (
        <RenewMotorLayout
          backClickHandler={handlePrevRenewal}
          show_summary
          btn_onClick={NextRenewalHandler}
        >
          <UploadScanRenewal />
        </RenewMotorLayout>
      )}
    </>
  );
};

export default UploadPhotosOfCar;